<template>
  <a-layout :style="{background:'#f1f3f3',minHeight:'100vh'}">
    <a-layout-content>
      <a-row>
        <a-col type="flex" justify="space-around" align="middle" class="wemail-login-box">
          <img src="@/assets/wemail.svg" alt class="we__logo">
        </a-col>
      </a-row>
      <a-row>
        <a-col type="flex" justify="space-around" align="middle" :style="{fontSize: '1.2em', margin: '20px', fontWeight: 'bold'}">
          Send Password Reset Link
        </a-col>
      </a-row>
      <a-row type="flex" justify="space-around" align="middle">
        <a-col :span="8">
          <a-form
            id="components-form-demo-normal-login"
            class="login-form height-50"
          >
            <a-form-item
                  :validate-status="errors.hasOwnProperty('email') ? 'error' : 'validating'"
                  :help="errors.hasOwnProperty('email') ? errors.email[0] : ''"
            >
              <a-input
                placeholder="Email Address"
                v-model="email"
              >
                <a-icon slot="prefix" type="user" style="color: rgba(0,0,0,.25)"/>
              </a-input>
            </a-form-item>
            <a-form-item>
              <a-button type="primary" @click.prevent="sendResetLink" :loading="loading" class="login-form-button">Send Password Reset Link</a-button>
              Or <router-link :to="{name: 'login'}" tag="a">Back to login</router-link>
            </a-form-item>
          </a-form>
        </a-col>
      </a-row>
    </a-layout-content>
  </a-layout>
</template>

<script>
export default {
  data() {
    return {
      email: '',
      errors: {},
      loading: false
    }
  },
  methods: {
    sendResetLink() {
      this.loading = true;
      this.errors = {};
      this.$store.dispatch("auth/SEND_PASSWORD_RESET_LINK", { email: this.email, type: 'admin' })
        .then(() => {
          this.$weNotify("success", `Password reset link was sent to '${this.email}'`);
          this.loading = false;
          this.email = "";
        }).catch(error => {
          if (error.data.type) {
            this.$weNotify("warning", "Unable to reset login password.");
          }
          this.errors = error.data;
          this.loading = false;
        })
    }
  }
};
</script>
<style scoped>
.body {
  width: 100%;
}
.we__logo {
  height: 80px;
  width: 80px;
}
.wemail-login-box {
  margin-top: 10%;
}
#components-form-demo-normal-login .login-form {
  max-width: 300px;
}
#components-form-demo-normal-login .login-form-forgot {
  float: right;
}
#components-form-demo-normal-login .login-form-button {
  width: 100%;
}
</style>
